// Mock data for BoraJunto - Carona/Transfer App

export const MOCK_USERS = [
  {
    id: 'u1',
    name: 'Giovanna Carolina Martins',
    email: 'giovanna@example.com',
    password: '123456',
    role: 'motorista',
    rating: 0.0,
    trips: 0,
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    status: 'ativo',
    verified: true,
    createdAt: '2026-06-01',
  },
  {
    id: 'u2',
    name: 'Célio Silva',
    email: 'celio@example.com',
    password: '123456',
    role: 'motorista',
    rating: 0.0,
    trips: 0,
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    status: 'ativo',
    verified: true,
    createdAt: '2026-06-10',
  },
  {
    id: 'u3',
    name: 'Mago Branco',
    email: 'magobranco322@gmail.com',
    password: '123456',
    role: 'passageiro',
    rating: 4.8,
    trips: 12,
    avatar: 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=200&h=200&fit=crop',
    status: 'ativo',
    verified: true,
    createdAt: '2026-05-15',
  },
  {
    id: 'u4',
    name: 'Ricardo Alves',
    email: 'ricardo@example.com',
    password: '123456',
    role: 'motorista',
    rating: 4.9,
    trips: 87,
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    status: 'ativo',
    verified: true,
    createdAt: '2026-04-20',
  },
  {
    id: 'u5',
    name: 'Ana Beatriz',
    email: 'ana@example.com',
    password: '123456',
    role: 'passageiro',
    rating: 4.7,
    trips: 6,
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop',
    status: 'bloqueado',
    verified: false,
    createdAt: '2026-07-01',
  },
  {
    id: 'admin',
    name: 'Admin VIP Litoral',
    email: 'admin@borajunto.com',
    password: 'admin',
    role: 'admin',
    rating: 5.0,
    trips: 0,
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop',
    status: 'ativo',
    verified: true,
    createdAt: '2026-01-01',
  },
];

export const MOCK_TRIPS = [
  {
    id: 't1',
    driverId: 'u1',
    driverName: 'Giovanna Carolina Martins',
    driverAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    rating: 0.0,
    driverTrips: 0,
    origin: 'Matinhos',
    destination: 'Curitiba',
    date: '05/08/2026',
    time: '18:00',
    seatsTotal: 4,
    seatsFilled: 0,
    price: 70,
    petFriendly: true,
    homePickup: true,
    status: 'ativa',
  },
  {
    id: 't2',
    driverId: 'u2',
    driverName: 'Célio',
    driverAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    rating: 0.0,
    driverTrips: 0,
    origin: 'Curitiba posto shell via sul',
    destination: 'Matinhos',
    date: '05/08/2026',
    time: '18:00',
    seatsTotal: 4,
    seatsFilled: 0,
    price: 65,
    petFriendly: false,
    homePickup: false,
    status: 'ativa',
  },
  {
    id: 't3',
    driverId: 'u4',
    driverName: 'Ricardo Alves',
    driverAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    rating: 4.9,
    driverTrips: 87,
    origin: 'Curitiba - Centro',
    destination: 'Guaratuba',
    date: '10/08/2026',
    time: '07:30',
    seatsTotal: 4,
    seatsFilled: 2,
    price: 55,
    petFriendly: true,
    homePickup: true,
    status: 'ativa',
  },
  {
    id: 't4',
    driverId: 'u4',
    driverName: 'Ricardo Alves',
    driverAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    rating: 4.9,
    driverTrips: 87,
    origin: 'Pontal do Paraná',
    destination: 'Curitiba - Rodoviária',
    date: '12/08/2026',
    time: '19:00',
    seatsTotal: 3,
    seatsFilled: 1,
    price: 80,
    petFriendly: false,
    homePickup: false,
    status: 'ativa',
  },
  {
    id: 't5',
    driverId: 'u1',
    driverName: 'Giovanna Carolina Martins',
    driverAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    rating: 0.0,
    driverTrips: 0,
    origin: 'Curitiba - Batel',
    destination: 'Praia de Leste',
    date: '15/08/2026',
    time: '06:00',
    seatsTotal: 4,
    seatsFilled: 0,
    price: 60,
    petFriendly: true,
    homePickup: false,
    status: 'ativa',
  },
];

export const MOCK_CHATS = [
  {
    id: 'c1',
    participants: ['u3', 'u1'],
    otherUserId: 'u1',
    otherUserName: 'Giovanna Carolina Martins',
    otherUserAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    lastMessage: 'Bom dia! A viagem confirma para 18h?',
    lastTime: '09:12',
    unread: 2,
    messages: [
      { id: 'm1', senderId: 'u3', text: 'Oi, tudo bem?', time: '08:50' },
      { id: 'm2', senderId: 'u1', text: 'Olá! Tudo sim, e você?', time: '08:52' },
      { id: 'm3', senderId: 'u3', text: 'Consigo uma vaga pra amanhã?', time: '09:00' },
      { id: 'm4', senderId: 'u1', text: 'Consegue sim, posso te buscar 17:30', time: '09:10' },
      { id: 'm5', senderId: 'u1', text: 'Bom dia! A viagem confirma para 18h?', time: '09:12' },
    ],
  },
  {
    id: 'c2',
    participants: ['u3', 'u2'],
    otherUserId: 'u2',
    otherUserName: 'Célio',
    otherUserAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    lastMessage: 'Beleza, te vejo lá!',
    lastTime: 'Ontem',
    unread: 0,
    messages: [
      { id: 'm1', senderId: 'u3', text: 'Confirmado, embarco no posto shell', time: '15:20' },
      { id: 'm2', senderId: 'u2', text: 'Beleza, te vejo lá!', time: '15:22' },
    ],
  },
  {
    id: 'c3',
    participants: ['u3', 'u4'],
    otherUserId: 'u4',
    otherUserName: 'Ricardo Alves',
    otherUserAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    lastMessage: 'Vou levar dois cachorros pequenos, tudo bem?',
    lastTime: '2 dias',
    unread: 0,
    messages: [
      { id: 'm1', senderId: 'u3', text: 'Oi Ricardo, sua viagem tem pet friendly?', time: '10:00' },
      { id: 'm2', senderId: 'u4', text: 'Sim, sem problema', time: '10:05' },
      { id: 'm3', senderId: 'u3', text: 'Vou levar dois cachorros pequenos, tudo bem?', time: '10:10' },
    ],
  },
];

export const MOCK_REPORTS = [
  {
    id: 'r1',
    type: 'usuario',
    targetId: 'u5',
    targetName: 'Ana Beatriz',
    reporterName: 'Célio',
    reason: 'Comportamento inadequado durante a viagem',
    date: '02/08/2026',
    status: 'pendente',
  },
  {
    id: 'r2',
    type: 'viagem',
    targetId: 't2',
    targetName: 'Curitiba → Matinhos (Célio)',
    reporterName: 'Ana Beatriz',
    reason: 'Motorista não apareceu no local combinado',
    date: '01/08/2026',
    status: 'pendente',
  },
  {
    id: 'r3',
    type: 'mensagem',
    targetId: 'm5',
    targetName: 'Mensagem em chat #c1',
    reporterName: 'Mago Branco',
    reason: 'Spam de link externo',
    date: '30/07/2026',
    status: 'resolvida',
  },
];

export const MOCK_PENDING_APPROVALS = [
  {
    id: 'p1',
    userId: 'u5',
    name: 'Ana Beatriz',
    email: 'ana@example.com',
    role: 'passageiro',
    submittedAt: '2026-07-30',
    documents: ['CNH.pdf', 'Selfie.jpg'],
  },
  {
    id: 'p2',
    userId: 'u_new1',
    name: 'Fernando Costa',
    email: 'fernando@example.com',
    role: 'motorista',
    submittedAt: '2026-08-01',
    documents: ['CNH.pdf', 'CRLV.pdf', 'Selfie.jpg'],
  },
];

export const CITIES = [
  'Curitiba', 'Matinhos', 'Guaratuba', 'Pontal do Paraná', 'Praia de Leste',
  'Paranaguá', 'São José dos Pinhais', 'Antonina', 'Morretes', 'Piraquara'
];
